export default {
  common: {
    inputIntegerTip: '请输入正整数'
  },
  company: {
    companySetting: '企业配置',
    userCount: '人员数量',
    expirationDate: '账号有效期',
    confirmedAccount: '确认账号',
    confirmedAccountTip: '您确认启用当前账号？'
  },
  licensePlate: {
    successTotal: '成功总数'
  },
  email: {
    details: '邮件详情',
    server: '邮箱服务器',
    port: '端口',
    account: '邮箱账号',
    password: '密码',
    sendername: '发送者名称',
    sender: '发送者',
    recipient: '接收者',
    subject: '主题',
    sendTime: '发送时间',
    status: '状态',
    emailsExpiryTip: '配置账号到期提醒',
    cronVal: '邮件发送频率(天)',
    testConnection: '测试连接',
    save: '保存',
    threshold: '距离账号有效期(天)',
    failReason: '失败原因',
    content: '邮件内容'
  },
  inspection: {
    sn: 'Sn',
    exceptionType: '异常类型',
    timesTip: '酒测仪使用次数(剩余/上限)',
    daysTip: '酒测仪使用天数(剩余/上限)',
    memory: '内存(可用/总量)',
    normal: '正常',
    exception: '异常',
    warning: '警告',
    storage: '存储(可用/总量)',
    inspectionTime: '巡检时间',
    warningContent: '告警内容',
    warningTime: '告警时间',
    companyCode: '企业编号',
    name: '企业名称',
    expiryData: '过期时间',
    status: '状态',
    onLine: '在线',
    expired: '已过期{number} 天',
    expiringSoon: '{number}天后过期',
    offLine: '离线',
    companyNumber: '企业数量',
    inspectionTableTitle: '设备巡检告警报告',
    companyExpiryTableTitle: '企业有效期报告'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/zh_cn/v1.js